var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTwitch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 14 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-twitch") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.83222222,3.05666667 L7.83222222,6.38555556 L6.72,6.38555556 L6.72,3.05666667 L7.83222222,3.05666667 Z M10.8888889,3.05666667 L10.8888889,6.38555556 L9.77666667,6.38555556 L9.77666667,3.05666667 L10.8888889,3.05666667 Z M3.11111111,0 L0.334444444,2.77666667 L0.334444444,12.7788889 L3.66333333,12.7788889 L3.66333333,15.5555556 L6.44777778,12.7788889 L8.66444444,12.7788889 L13.6655556,7.77777778 L13.6655556,0 M12.5533333,7.22555556 L10.3366667,9.44222222 L8.11222222,9.44222222 L6.16777778,11.3866667 L6.16777778,9.44222222 L3.66333333,9.44222222 L3.66333333,1.11222222 L12.5533333,1.11222222 L12.5533333,7.22555556 Z",
    id: "icon-twitch",
    fill: "#6441A5",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitch);
export default __webpack_public_path__ + "static/media/icon-twitch.3bc3f40cc72635993e185bf9cb4fe30f.svg";
export { ForwardRef as ReactComponent };